import React from 'react';
import ASCII from '../components/ASCII';
import styles from '../styles/about.module.css';
import Polaroid from '../components/PolaroidCard';
import AudioPlayer from '../components/AudioPlayer';

import iGiorni from '../audio/I Giorni - Jared.mp3';
import QueenOfSheba from '../audio/Queen Of Sheba - Jared.mp3';
import brisket from '../images/foodImgs/brisket.JPG';
import burrito from '../images/foodImgs/burritoBowl.jpg';
import monkfish from '../images/foodImgs/monkfish.jpg';
import risotto from '../images/foodImgs/octopusRisotto.jpg';
import paella from '../images/foodImgs/paella.jpg';
import sourdough from '../images/foodImgs/sourdough.jpg';

const About = () => {
  return (
    <div className={styles.aboutContainer}>
      <div className={styles.aboutContent}>
        <ASCII />
        <div className={styles.aboutText}>
          <h1>{"//"} About Me</h1>
          <p>{">"} Hi, I'm Jared Santoro.</p>
          <p>I specialise in web design and development, blending usability with unique, artistic designs.</p>
          <p>With a background rooted in a family company focused on art and design, I bring a seasoned eye and creative approach to every project.</p>
          <p>With a degree in Computer Science, my expertise extends well beyond web coding. I am constantly seeking new and exciting opportunities in the tech industry.<span className={styles.blinkingCursor}>█</span></p>
        </div>
      </div>
      <div className={styles.otherInterests}>
        <div className={`${styles.interestText} ${styles.interestBox}`}>
          <h1>{"//"} Cooking</h1>
          <p>{">"} Beyond coding, I'm an avid cook, inspired by my diverse cultural background and experiences.</p>
          <p>My love for cooking, much like my passion for development, is rooted in creativity, adaptation, and problem-solving.</p> 
          <p>Just as I enjoy experimenting with flavors and techniques in the kitchen, I thrive on tackling challenges and finding innovative solutions in my coding projects.</p>
          <p>Have a look at of some of the dishes I've prepared!</p>
        </div>
        <div className={`${styles.polaroidPics} ${styles.interestBox}`}>
          <Polaroid src={brisket} caption="Smoked Brisket" />
          <Polaroid src={burrito} caption="Burrito Bowl" />
          <Polaroid src={monkfish} caption="Spiced Monkfish" />
          <Polaroid src={risotto} caption="Octopus Risotto" />
          <Polaroid src={paella} caption="Seafood Paella" />
          <Polaroid src={sourdough} caption="Sourdough Boule" />
        </div>
      </div>
      <div className={styles.otherInterests}>
        <div className={`${styles.interestText} ${styles.interestBox}`}>
          <h1>{"//"} Music</h1>
          <p>{">"} I have a deep appreciation for all types of music, which fuels my inspiration and passion.</p>
          <p>Playing the piano is one of my greatest joys, allowing me to express myself and explore different musical genres.</p> 
          <p>This love for music complements my work as a developer, where determination, practice and adaptability play a crucial role.</p>
          <p>Have a listen to some of these pieces played by me!</p>
        </div>
        <div className={`${styles.musicBox} ${styles.interestBox}`}>
          <AudioPlayer title="I Giorni" by="by Ludovico Eiunaudi" track={iGiorni} rate={1} />
          <AudioPlayer title="Arrival of the Queen of Sheba" by="by Handel" track={QueenOfSheba} rate={0.85} />
        </div>
      </div>
    </div>
  );
};
  
export default About;